import { Clock, Mail, MapPin, Phone } from "lucide-react";
import EstimateForm from "@/components/EstimateForm";
import OwnerSection from "@/components/Owner";
import { Overline, Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { AREAS, COMPANY, OTHER_AREAS } from "@/data/site";

const INFO = [
  { icon: Phone, label: "Call or Text", value: COMPANY.phone, href: COMPANY.phoneHref, testid: "contact-phone-link" },
  { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: "contact-email-link" },
  { icon: Clock, label: "Hours", value: COMPANY.hours, testid: "contact-hours" },
  { icon: MapPin, label: "Based In", value: COMPANY.city, testid: "contact-location" },
];

const ContactPage = () => (
  <>
    <SEO
      title="Contact Gregory Tile | Free Remodeling Estimates in Huntsville, AL"
      description="Contact Gregory Tile & Home Remodeling for a free estimate on bathroom, kitchen, or flooring remodeling in Huntsville, Madison, Athens and surrounding Alabama counties."
    />
    <section className="bg-navy py-16 md:py-24" data-testid="contact-page">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-2 lg:px-10">
        <Reveal>
          <Overline light>Contact Us</Overline>
          <h1 className="mt-3 font-serif text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Let's Talk About Your Remodel
          </h1>
          <p className="mt-4 max-w-md text-base leading-relaxed text-white/70">
            Call, email, or send the form — we'll respond within one business day with next steps and a free in-home estimate.
          </p>

          <div className="mt-10 grid gap-4 sm:grid-cols-2">
            {INFO.map((item) => (
              <div key={item.label} className="rounded-2xl border border-white/15 bg-white/5 p-5">
                <item.icon className="h-5 w-5 text-salmon-vibrant" />
                <p className="mt-3 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                  {item.label}
                </p>
                {item.href ? (
                  <a
                    href={item.href}
                    data-testid={item.testid}
                    className="mt-1 block text-sm font-bold text-white transition-colors hover:text-salmon-vibrant"
                  >
                    {item.value}
                  </a>
                ) : (
                  <p data-testid={item.testid} className="mt-1 text-sm font-bold text-white">{item.value}</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-white/15 bg-white/5 p-5">
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
              Service Area
            </p>
            <p className="mt-2 text-sm leading-relaxed text-white/80">
              {[...AREAS.map((a) => a.name), ...OTHER_AREAS].join(" · ")} — and surrounding communities across Madison, Limestone & Morgan counties.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <EstimateForm
            idPrefix="contact"
            title="Request Your Free Estimate"
            subtitle="We typically respond within a few hours during business hours."
            full
            source="contact-page"
          />
        </Reveal>
      </div>
    </section>

    <OwnerSection />
  </>
);

export default ContactPage;
